module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[15]502.d6edf15.woff2";